import React from 'react';
import PropTypes from 'prop-types';
import User from 'records/User';
import CoachingReview from 'records/CoachingReview';
import UserAvatar from 'components/pure/utils/UserAvatar';
import './CoachingAgendaCard.styl';
import moment from 'moment';
import classNames from 'classnames';
import PlanSettingsIcon from 'components/coaching/landing-pages/helpers/buttons/PlanSettingsIcon';
import withCoachingPlanWizard from 'components/coaching/wizard/withCoachingPlanWizard';
import InProgressReview from 'records/InProgressReview';
import {CalendarDaysIcon} from '@components/icon/CalendarDaysIcon';

export const PENDING_CLASS = Object.freeze({
  READY: 'ready',
  COACH: 'pending-coach',
  REP: 'pending-rep',
});

class CoachingAgendaCard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showReschedule: false,
      hovered: false,
      menuOpen: false,
    };

    this.onHover = this.onHover.bind(this);
    this.onLeave = this.onLeave.bind(this);

    this.onMenuOpen = this.onMenuOpen.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
  }

  onHover() {
    this.setState({hovered: true});
  }

  onLeave() {
    this.setState({hovered: false});
  }

  onMenuOpen() {
    this.setState({menuOpen: true});
  }

  onMenuClose() {
    this.setState({menuOpen: false});
  }

  render() {
    const {
      rep,
      review,
      children,
      pendingType,
      className,
      suppressHover,
      onClick,
      refreshCoachingData,
      suppressEdit,
      plans,
    } = this.props;

    const {hovered, menuOpen} = this.state;

    const plan = plans.find(p => p.id === review.planId);
    if (!plan) return null;

    const formattedTime = review.scheduleAt.format('ddd M/D, h:mmA');
    const overdue = moment().isAfter(review.scheduleAt) && !review.completedAt;

    const showExpandedContent = hovered || menuOpen;

    return (
      <div
        className={classNames(
          'coaching-agenda-card',
          PENDING_CLASS[pendingType],
          className,
          onClick && 'pointer'
        )}
        onClick={onClick}
        onMouseEnter={this.onHover}
        onMouseLeave={this.onLeave}>
        <div className="review-info">
          <div className="flex-wrapper">
            <UserAvatar user={rep} />
            <div>
              <div className="rep-name">{rep.getFullName()}</div>
              <div className="time-info">
                {review.adHoc ? (
                  <div className="coach-now">COACH-NOW</div>
                ) : overdue ? (
                  <div className="overdue">PAST-DUE</div>
                ) : (
                  <div className="calendar-wrapper">
                    <CalendarDaysIcon tooltip="Time" />
                  </div>
                )}
                <span className="time">{formattedTime}</span>
              </div>
            </div>
          </div>
          <PlanSettingsIcon
            plan={plan}
            review={review}
            rep={rep}
            refreshCoachingData={refreshCoachingData}
            reviewFocused
            onMenuOpen={this.onMenuOpen}
            onMenuClose={this.onMenuClose}
            hide={!showExpandedContent || suppressEdit}
          />
        </div>
        {showExpandedContent && !suppressHover && (
          <div className="expanded-content">{children}</div>
        )}
      </div>
    );
  }
}

CoachingAgendaCard.propTypes = {
  rep: PropTypes.instanceOf(User),
  pendingType: PropTypes.oneOf(Object.keys(PENDING_CLASS)),
  review: PropTypes.oneOfType([
    PropTypes.instanceOf(CoachingReview), // Must have upcoming review fields
    PropTypes.instanceOf(InProgressReview), // For in-progress, ad-hoc reviews
  ]),
};

export default withCoachingPlanWizard(CoachingAgendaCard);
